/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * FR API Documentation
 * OpenAPI spec version: 1
 */

export type DocumentFieldItem = typeof DocumentFieldItem[keyof typeof DocumentFieldItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DocumentFieldItem = {
  abstract: 'abstract',
  action: 'action',
  agencies: 'agencies',
  agency_names: 'agency_names',
  amendatory_instruction_count: 'amendatory_instruction_count',
  body_html_url: 'body_html_url',
  cfr_references: 'cfr_references',
  citation: 'citation',
  comment_url: 'comment_url',
  comments_close_on: 'comments_close_on',
  correction_of: 'correction_of',
  corrections: 'corrections',
  dates: 'dates',
  disposition_notes: 'disposition_notes',
  docket_id: 'docket_id',
  docket_ids: 'docket_ids',
  dockets: 'dockets',
  document_number: 'document_number',
  effective_on: 'effective_on',
  end_page: 'end_page',
  excerpts: 'excerpts',
  executive_order_notes: 'executive_order_notes',
  executive_order_number: 'executive_order_number',
  explanation: 'explanation',
  full_text_xml_url: 'full_text_xml_url',
  html_url: 'html_url',
  images: 'images',
  images_metadata: 'images_metadata',
  json_url: 'json_url',
  mods_url: 'mods_url',
  not_received_for_publication: 'not_received_for_publication',
  page_length: 'page_length',
  page_views: 'page_views',
  pdf_url: 'pdf_url',
  president: 'president',
  presidential_document_number: 'presidential_document_number',
  proclamation_number: 'proclamation_number',
  public_inspection_pdf_url: 'public_inspection_pdf_url',
  publication_date: 'publication_date',
  raw_text_url: 'raw_text_url',
  regulation_id_number_info: 'regulation_id_number_info',
  regulation_id_numbers: 'regulation_id_numbers',
  regulations_dot_gov_info: 'regulations_dot_gov_info',
  regulations_dot_gov_url: 'regulations_dot_gov_url',
  related_documents: 'related_documents',
  significant: 'significant',
  signing_date: 'signing_date',
  start_page: 'start_page',
  subtype: 'subtype',
  title: 'title',
  toc_doc: 'toc_doc',
  toc_subject: 'toc_subject',
  topics: 'topics',
  type: 'type',
  volume: 'volume',
} as const;
